// export const BASE_URL = 'https://emerald-pos-api.beetronix.com/api'
// export const BASE_URL = 'http://beeserver:114/api'
// export const BASE_URL = 'https://localhost:39472/api'

/* mirta */
export const BASE_URL = 'https://pos-api.mirta.net/api'
/* mirta mirror */
// export const BASE_URL = 'https://pos-mirror-api.emeraldsystem.net/api'

// Attar
// export const BASE_URL = 'https://pos-1-api.beetronix.com/api'
// export const BASE_URL = 'https://pos-2-api.beetronix.com/api'
// export const BASE_URL = 'https://pos-3-api.beetronix.com/api'
// export const BASE_URL = 'https://pos-4-api.beetronix.com/api'

// export const BASE_URL = 'https://kadou-pos-api.emeraldsystem.net/api'

// export const BASE_URL = 'http://localhost:39472/api/'
export const VERSION = '1.19.0'